/**
 * Desktop header dropdowns: keep click behavior, add hover open/close.
 */
function initEspaceHeaderDropdowns() {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  const dropdowns = Array.from(document.querySelectorAll('.header__inline-menu header-menu > details'));
  if (!dropdowns.length) return;

  let closeTimer = null;

  const closeAll = (except) => {
    dropdowns.forEach((details) => {
      if (details === except) return;
      details.removeAttribute('open');
    });
  };

  dropdowns.forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;

    details.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      window.clearTimeout(closeTimer);
      closeAll(details);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      closeTimer = window.setTimeout(() => {
        details.removeAttribute('open');
      }, 180);
    });

    summary.addEventListener('click', () => {
      if (!isDesktop()) return;
      // Allow native details toggle, but keep only one dropdown open.
      window.setTimeout(() => {
        if (details.hasAttribute('open')) closeAll(details);
      }, 0);
    });
  });

  document.addEventListener('click', (event) => {
    if (!isDesktop()) return;
    if (event.target.closest('.header__inline-menu')) return;
    closeAll();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEspaceHeaderDropdowns);
} else {
  initEspaceHeaderDropdowns();
}

